import { Backdrop, Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useSelector } from "react-redux";

const LoadingBackdrop = () => {
  const theme = useTheme();
  const { isLoading } = useSelector((state) => state.global);
  const accent = theme.palette.secondary.main;

  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: 9999,
        backgroundColor: alpha(theme.palette.primary[900], 0.5),
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: 5,
          py: 4,
          minWidth: 220,
          borderRadius: 4,
          overflow: "hidden",
          color: "text.primary",
          backgroundColor: "background.paper",
          border: `1px solid ${alpha(theme.palette.primary[900], 0.08)}`,
          boxShadow: "0 24px 60px rgba(17, 31, 55, 0.24)",
        }}
      >
        {/* Spinner dengan pulse lembut */}
        <Box sx={{ position: "relative", width: 64, height: 64, display: "grid", placeItems: "center" }}>
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              backgroundColor: alpha(accent, 0.14),
              animation: "primaPulse 1.8s ease-out infinite",
            }}
          />
          <CircularProgress
            size={52}
            thickness={3.6}
            sx={{ color: accent, position: "relative" }}
          />
          <Box
            sx={{
              position: "absolute",
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: accent,
            }}
          />
        </Box>

        <Typography sx={{ mt: 2.5, fontWeight: 800, fontSize: 15, letterSpacing: "-0.01em" }}>
          Tunggu sebentar
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
          Sedang memuat data…
        </Typography>

        <Box sx={{ display: "flex", gap: 0.9, mt: 2 }}>
          {[0, 1, 2].map((i) => (
            <Box
              key={i}
              sx={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                backgroundColor: alpha(accent, 0.9),
                animation: "primaDot 1.2s ease-in-out infinite",
                animationDelay: `${i * 0.16}s`,
              }}
            />
          ))}
        </Box>
      </Box>
    </Backdrop>
  );
};

export default LoadingBackdrop;
